export default __webpack_public_path__ + "static/media/discount-capital.ee4bf1a8.png";